import useTranslations from '@/i18n/useTranslations';
import AgreementContent from '@/pages/information/artwork-agreement/AgreementContent';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import PopupToBottomSheet from '@/shared-components/popups/components/PopupToBottomSheet';

import './styles/ArtworkTerms.css';

export default function ArtworkTerms({ open, close }) {
  const t = useTranslations('common.forms.add_artwork');
  return (
    <>
      <PopupToBottomSheet className="artwork-terms" open={open} close={close} popupOptions={{ opacity: true }}>
        <div className="artwork-terms-container">
          <div className="artwork-terms__header">
            <h3 className="artwork-terms__header-text">{t('checkboxes.artwork_agreement')}</h3>
            <XIcon className="artwork-terms__close" onClick={close}/>
          </div>

          <AgreementContent />
        </div>
      </PopupToBottomSheet>
    </>
  );
}
